"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.opIs = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
exports.opIs = {
    // --------------
    // ROOT COMMANDS	- use nothing but private functions
    // --------------
    onDemand: (op) => {
        if (!op)
            return false;
        return !!op.isAdhoc;
    },
    started: (op) => {
        if (!op)
            return false;
        return !!op.actualStart && !op.actualComplete;
    },
    approvable: (op) => {
        return op.awaitingApproval;
    },
    submitted: (op) => {
        if (!op)
            return false;
        return !!op.actualComplete;
    },
    closed: (op) => {
        return !!op.closedDate || (!!op.actualComplete && !op.awaitingApproval);
    },
    // --------------
    // BASIC COMMANDS	- use private functions and roots
    // --------------
    missed: (op) => {
        if (!op)
            return false;
        return !exports.opIs.onDemand(op) && !exports.opIs.submitted(op) && (0, moment_timezone_1.default)().isAfter(op.missedDeadlineDate);
    },
    early: (op) => {
        if (!op)
            return false;
        return inEarlyTimeWindow(op) && !exports.opIs.submitted(op) && !exports.opIs.closed(op);
    },
    performableOnTime: (op) => {
        if (!op)
            return false;
        return inToDoTimeWindow(op) && !exports.opIs.missed(op) && !exports.opIs.submitted(op) && !exports.opIs.closed(op);
    },
    performableLate: (op) => {
        if (!op)
            return false;
        return ((exports.opIs.onDemand(op) || inLateTimeWindow(op)) &&
            !exports.opIs.missed(op) &&
            !exports.opIs.submitted(op) &&
            !exports.opIs.closed(op));
    },
    submittedOnTime: (op) => {
        if (!op)
            return false;
        const isSubmitted = exports.opIs.submitted(op);
        if (!op.startFrom)
            return isSubmitted && (0, moment_timezone_1.default)(op.actualComplete).isSameOrBefore(op.completeBy);
        return (isSubmitted &&
            (0, moment_timezone_1.default)(op.actualComplete).isBetween(op.startFrom, op.completeBy, undefined, '[]'));
    },
    submittedLate: (op) => {
        if (!op)
            return false;
        return exports.opIs.submitted(op) && (0, moment_timezone_1.default)(op.actualComplete).isAfter(op.completeBy);
    },
    // --------------
    // COMPLEX COMMANDS	- use private functions, roots and basic cmmands
    // --------------
    performable: (op) => {
        if (!op)
            return false;
        return exports.opIs.performableOnTime(op) || exports.opIs.performableLate(op);
    },
    late: (op) => {
        if (!op)
            return false;
        return inLateTimeWindow(op) && (exports.opIs.performableLate(op) || exports.opIs.submittedLate(op));
    },
    performableStarted: (op) => {
        if (!op)
            return false;
        return exports.opIs.performable(op) && exports.opIs.started(op);
    },
    performableNotStarted: (op) => {
        if (!op)
            return false;
        return exports.opIs.performable(op) && !exports.opIs.started(op);
    },
    performableOnTimeNotStarted: (op) => {
        if (!op)
            return false;
        return exports.opIs.performableOnTime(op) && !exports.opIs.started(op);
    },
    performableOnTimeStarted: (op) => {
        if (!op)
            return false;
        return exports.opIs.performableOnTime(op) && exports.opIs.started(op);
    },
    performableLateNotStarted: (op) => {
        if (!op)
            return false;
        return exports.opIs.performableLate(op) && !exports.opIs.started(op);
    },
    performableLateStarted: (op) => {
        if (!op)
            return false;
        return exports.opIs.performableLate(op) && exports.opIs.started(op);
    },
    actionable: (op) => {
        if (!op)
            return false;
        return exports.opIs.performable(op) || exports.opIs.approvable(op);
    },
};
exports.default = exports.opIs;
// now < startFrom
function inEarlyTimeWindow(op) {
    if (!op)
        return false;
    if (!op.startFrom)
        return false;
    return (0, moment_timezone_1.default)().isBefore(op.startFrom);
}
// startFrom < now < completeBy
function inToDoTimeWindow(op) {
    if (!op)
        return false;
    if (!op.startFrom)
        return (0, moment_timezone_1.default)().isSameOrBefore(op.completeBy);
    return (0, moment_timezone_1.default)().isSameOrAfter(op.startFrom) && (0, moment_timezone_1.default)().isSameOrBefore(op.completeBy);
}
// completeBy < now < missed
function inLateTimeWindow(op) {
    if (!op)
        return false;
    if (!op.startFrom)
        return (0, moment_timezone_1.default)().isAfter(op.completeBy);
    const isLate = (0, moment_timezone_1.default)().isAfter(op.completeBy);
    const isMissed = inMissedTimeWindow(op);
    return isLate && !isMissed;
}
// missed < now
function inMissedTimeWindow(op) {
    if (!op)
        return false;
    if (op.missedDeadlineDate)
        return (0, moment_timezone_1.default)().isAfter((0, moment_timezone_1.default)(op.missedDeadlineDate));
    return (0, moment_timezone_1.default)().isAfter((0, moment_timezone_1.default)(op.completeBy).add(1, 'day'));
}
